import moment from "moment";
import 'moment/dist/locale/ru.js'


export default defineNuxtPlugin(nuxtApp => {
    moment.updateLocale('ru', null)
    nuxtApp.provide('moment', moment)
})